<template>
    <div id="top_head" class="flex reflex justifycont-b">
        <!-- <div class="site_logo"><router-link to="/">システムロゴ</router-link></div> -->
        <div id="site_title">
            <router-link to="/"><h1><span class="companyName">青森市ボランティアセンター</span><span>体験ボランティア</span></h1></router-link>
        </div>
        <div class="user_button">
			<!-- ログイン済みのボタン -->
			<div v-if="(login.sex)">
            <div class="user_button_item"><router-link to="/mypage" class="button btn_mypage">
            <!-- <button class="btn_mypage"> -->
                <fa icon="user-circle" class="icon fa-user"></fa>&ensp;マイページ
            <!-- </button> -->
            </router-link></div>
            <div class="user_button_item"><button class="button btn_logout" @click="isLogout"><fa icon="sign-out-alt" class="icon fa-user"></fa>&ensp;ログアウト</button>
			</div></div>
			<!-- 未ログイン時のボタン -->
			<div v-else>
            <div class="user_button_item"><router-link to="/Login" class="button btn_login">
            <!-- <button class="btn_login"> -->
                <fa icon="user" class="icon fa-user"></fa>&ensp;ログイン
                <!-- </button> -->
            </router-link></div>
            <div class="user_button_item"><router-link to="/katudo-touroku/first" class="button btn_new">
            <!-- <button class="btn_new"> -->
                <fa icon="user-plus" class="icon fa-user-plus"></fa>&ensp;新規登録
            <!-- </button> -->
            </router-link></div>
			</div>
        </div>
    </div>
</template>

<script>
import { inject } from 'vue';
export default {
	setup () {
		const { login, isLogout } = inject('loginstate');
		return {
			login,
			isLogout,
		}
	},
}

</script>

<style scoped>

</style>